export default __webpack_public_path__ + "static/media/filter-dark-icon.4f886cba.svg";